import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {ModuleVisibility} from '../../../../data/model/moduleVisibility';
import {SignedRequest} from '../../../../data/model/signedRequest';
import {ModulesDataManager} from '../../../../data/modules.datamanager';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component(
    {selector: 'add-module-dialog', templateUrl: './add-module-dialog.html'})
export class AddModuleDialogComponent {
  statusText = 'starting upload';
  name = '';
  isExam = false;
  value = 50;
  showProgress = false;
  module: File = null;
  image: File = null;
  nameInput = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<AddModuleDialogComponent>,
      private uploadDataManager: UploadDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      private modulesDataManager: ModulesDataManager,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  handleImageInput(files: FileList) {
    this.image = files.item(0);
  }

  handleModuleInput(files: FileList) {
    this.module = files.item(0);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onAddClick(name: string): void {
    this.showProgress = true;
    this.uploadDataManager.getSignedUpload(this.module.name, this.module.type)
        .subscribe(
            (moduleSignedResponse) => {
              this.statusText = 'Uploading module';
              this.uploadDataManager
                  .uploadFileToS3(moduleSignedResponse, this.module)
                  .subscribe(
                      (moduleResponse) => {
                        if (typeof moduleResponse === 'string') {
                          this.uploadImage(moduleSignedResponse, name);
                        } else {
                          this.value = moduleResponse;
                        }
                      },
                      (err) => {
                        console.log(err);
                        this.closeDialogWithError(err.json());
                      });
            },
            (err) => {
              console.log(err);
              this.closeDialogWithError(err.json());
            });
  }

  uploadImage(moduleSignedResponse: SignedRequest, name: string) {
    this.statusText = 'Uploading image';
    this.value = 0;
    this.uploadDataManager.getSignedUpload(this.image.name, this.image.type)
        .subscribe(
            (imageSignedResponse) => {
              this.uploadDataManager
                  .uploadFileToS3(imageSignedResponse, this.image)
                  .subscribe(
                      (imageResponse) => {
                        if (typeof imageResponse === 'string') {
                          this.createNewTrainingModule(
                              moduleSignedResponse, imageSignedResponse, name);
                        } else {
                          this.value = imageResponse;
                        }
                      },
                      (err) => {
                        console.log(err);
                        this.closeDialogWithError(err.json());
                      });
            },
            (err) => {
              console.log(err);
              this.closeDialogWithError(err.json());
            });
  }

  createNewTrainingModule(
      moduleSignedResponse: SignedRequest, imageSignedResponse: SignedRequest,
      name: string) {
    this.statusText = 'Creating training module';


    this.organisationsDataManager.getAllOrganisations().subscribe(
        (response) => {
          const visibilityList: ModuleVisibility[] = [];
          response.forEach(organisation => {
            let visibility = new ModuleVisibility();
            visibility.organisation = organisation._id;
            visibility.visible = false;
            visibility.role = 'appuser';
            visibilityList.push(visibility);

            visibility = new ModuleVisibility();
            visibility.organisation = organisation._id;
            visibility.visible = false;
            visibility.role = 'admin';
            visibilityList.push(visibility);

            visibility = new ModuleVisibility();
            visibility.organisation = organisation._id;
            visibility.visible = false;
            visibility.role = 'instructor';
            visibilityList.push(visibility);
          });

          this.modulesDataManager
              .createModule(
                  name, imageSignedResponse.url, moduleSignedResponse.url,
                  visibilityList, this.isExam)
              .subscribe(
                  (res) => {
                    this.closeDialogSuccess('succesfully created: ' + res.name);
                  },
                  (err) => {
                    console.log(err);
                    this.closeDialogWithError(err.json());
                  });
        },
        (err) => {
          console.log(err);
          this.closeDialogWithError(err.json());
        });
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }

  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  openModuleUpload() {
    document.getElementById('module-id').click();
  }

  openImageUpload() {
    document.getElementById('image-id').click();
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/add/add.module.dialog.component.ts